import { Controller } from "@hotwired/stimulus"

// Controla a busca client-side no dropdown
export default class extends Controller {
  static targets = ["items", "query", "item", "empty"]
  static values = {
    emptyText: { type: String, default: "Nenhum resultado" }
  }

  connect() {
    focus();
  }

  filter(e) {
    let query = this.queryTarget.value.toLowerCase()
    this.itemsTargets.forEach((el)=> {
      if(el.dataset.value.toLowerCase().includes(query)){
        el.classList.remove('hidden')
      } else {
        el.classList.add('hidden')
      };
    })
  }

  clear() {
    if (!this.hasInputTarget) return
    this.inputTarget.value = ""
    this.filter()
  }

  focus() {
    setTimeout(() => {
      this.queryTarget?.focus()
    }, 100);
  }

  normalized(str) {
    return (str || "")
      .toLocaleLowerCase()
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "") // remove acentos
      .trim()
  }

  toggleEmpty(show) {
    // Cria o elemento "Nenhum resultado" uma única vez
    if (!this.hasEmptyTarget) {
      const li = document.createElement("li")
      li.dataset.dropdownFilterTarget = "empty"
      li.className = "px-3 py-2 text-gray-500 text-sm"
      li.textContent = this.emptyTextValue
      li.classList.add("hidden")
      this.listTarget.appendChild(li)
    }
    this.emptyTarget.classList.toggle("hidden", !show)
  }
}

